import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-77b15527"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "tab_container"
};
import { computed, defineAsyncComponent, ref } from 'vue';
import { reportEvent } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const tabKey = ref('taskWarning');
    const tabList = [{
      key: 'taskWarning',
      label: '预警任务',
      component: defineAsyncComponent(() => import('./taskWarning/index.vue'))
    }, {
      key: 'thresholdPlan',
      label: '阀值方案',
      component: defineAsyncComponent(() => import('./thresholdPlan/index.vue'))
    }];
    function handleTabChange(key) {
      var _tabList$find;
      tabKey.value = key;
      const tablabel = (_tabList$find = tabList.find(item => item.key === key)) === null || _tabList$find === void 0 ? void 0 : _tabList$find.label;
      reportEvent({
        eventName: 'element_use',
        properties: {
          ui_name: '订单监控',
          element_name: `切换${tablabel}`
        }
      });
    }
    const curComp = computed(() => {
      var _tabList$find$compone, _tabList$find2;
      return (_tabList$find$compone = (_tabList$find2 = tabList.find(item => item.key === tabKey.value)) === null || _tabList$find2 === void 0 ? void 0 : _tabList$find2.component) !== null && _tabList$find$compone !== void 0 ? _tabList$find$compone : tabList[0].component;
    });
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_tabs, {
        activeKey: tabKey.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => tabKey.value = $event),
        onChange: handleTabChange
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabList, item => {
          return _createVNode(_component_a_tab_pane, {
            key: item.key,
            tab: item.label
          }, null, 8, ["tab"]);
        }), 64))]),
        _: 1
      }, 8, ["activeKey"])]), (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(curComp))))])]);
    };
  }
});